(function () {
  'use strict';

  var STORAGE_KEY = 'gad_assessment';
  var container = null;
  var config = null;
  var assetUrlBase = '';
  var state = {
    currentId: null,
    answers: {},
    history: [],
    selectedOption: null,
    selectedTier: null
  };

  var redirectCountdownTimer = null;
  var redirectCountdownInterval = null;

  function clearRedirectCountdown() {
    if (redirectCountdownTimer) {
      clearTimeout(redirectCountdownTimer);
      redirectCountdownTimer = null;
    }
    if (redirectCountdownInterval) {
      clearInterval(redirectCountdownInterval);
      redirectCountdownInterval = null;
    }
  }

  function hasEmailParam() {
    try {
      return !!(new URLSearchParams(window.location.search).get('email'));
    } catch (e) {
      return false;
    }
  }

  var arrowRightSvg = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M10 18.3333C14.6024 18.3333 18.3334 14.6024 18.3334 10C18.3334 5.39762 14.6024 1.66666 10 1.66666C5.39765 1.66666 1.66669 5.39762 1.66669 10C1.66669 14.6024 5.39765 18.3333 10 18.3333Z" stroke="white" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M8.94995 12.9417L11.8833 10L8.94995 7.05833" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  var arrowLeftSvg = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M9.57 5.93L3.5 12L9.57 18.07" stroke="#CE3E84" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M20.5 12H3.67" stroke="#CE3E84" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  function saveState() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        currentId: state.currentId,
        answers: state.answers,
        history: state.history
      }));
    } catch (e) { /* silent */ }
    window.gadAssessmentState = state;
  }

  function loadState() {
    try {
      var saved = localStorage.getItem(STORAGE_KEY);
      if (saved) {
        var parsed = JSON.parse(saved);
        state.currentId = parsed.currentId || null;
        state.answers = parsed.answers || {};
        state.history = parsed.history || [];
        return true;
      }
    } catch (e) { /* silent */ }
    return false;
  }

  function clearState() {
    state = { currentId: null, answers: {}, history: [], selectedOption: null, selectedTier: null };
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) { /* silent */ }
  }

  function getQuestion(id) {
    for (var i = 0; i < config.questions.length; i++) {
      if (config.questions[i].id === id) return config.questions[i];
    }
    return null;
  }

  function scrollToTop() {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }

  function goTo(nextId) {
    if (!nextId) return;
    if (nextId === 'q15' && state._q7Queue && state._q7Queue.length > 0) {
      nextId = state._q7Queue.shift();
    }
    if (nextId === 'q21' && state._q15Queue && state._q15Queue.length > 0) {
      nextId = state._q15Queue.shift();
    }
    if (nextId === 'q31' && state._q21Queue && state._q21Queue.length > 0) {
      nextId = state._q21Queue.shift();
    }
    state.history.push(state.currentId);
    state.currentId = nextId;
    state.selectedOption = null;
    state.selectedTier = null;
    saveState();
    render();
    scrollToTop();

    if (nextId === 'recommendation-loading' && window.gadAssessmentApi && typeof window.gadAssessmentApi.submit === 'function') {
      state._apiSubmitPending = true;
      state._apiSubmitError = null;
      window.gadAssessmentApi.submit()
        .then(function (data) {
          state._apiSubmitPending = false;
          if (data && data.success) {
            state._apiSubmitSuccess = true;
          } else {
            var errMsg = (data && data.message) ? data.message : (data && data.error) ? data.error : 'Submission failed. Please try again.';
            state._apiSubmitError = errMsg;
            state._apiSubmitSuccess = false;
          }
        })
        .catch(function (err) {
          state._apiSubmitPending = false;
          state._apiSubmitSuccess = false;
          state._apiSubmitError = 'Network error. Please check your connection and try again.';
        });
    }
  }

  function goBack() {
    if (state.history.length === 0) return;
    state.currentId = state.history.pop();
    state.selectedOption = null;
    state.selectedTier = null;
    saveState();
    render();
    scrollToTop();
  }

  function selectAnswer(questionId, value) {
    state.answers[questionId] = value;
    saveState();
  }

  /* ---- Renderers ---- */

  var MAX_STEPS = 20;

  function getAutoProgress() {
    var step = state.history.length;
    var pct = Math.min(Math.round((step / MAX_STEPS) * 100), 99);
    return pct;
  }

  function renderProgressBar() {
    var progress = getAutoProgress();
    var styleEl = document.getElementById('gad-progress-style');
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = 'gad-progress-style';
      document.head.appendChild(styleEl);
    }
    styleEl.textContent =
      '#gad-progress-fill { width: ' + Math.max(progress, 1) + '% !important; background-color: #033038 !important; display: block !important; height: 5px !important; min-width: 2px !important; opacity: 1 !important; visibility: visible !important; border-radius: 4px !important; transition: width 0.3s ease !important; }';
    return '<div class="assessment__progress">' +
      '<span class="assessment__progress-label">' + progress + '%</span>' +
      '<div class="assessment__progress-track">' +
      '<div id="gad-progress-fill" class="assessment__progress-fill"></div>' +
      '</div>' +
      '</div>';
  }

  function renderBackButton() {
    return '<button type="button" class="assessment__back" data-action="back">' +
      '<span class="assessment__back-icon">' + arrowLeftSvg + '</span>' +
      '<span class="assessment__back-text">Back</span>' +
      '</button>';
  }

  function renderPrimaryButton(label, disabled, action) {
    var cls = 'assessment__btn-primary' + (disabled ? ' is-disabled' : '');
    var disabledAttr = disabled ? ' disabled' : '';
    return '<button type="button" class="' + cls + '" data-action="' + (action || 'next') + '"' + disabledAttr + '>' +
      '<span>' + (label || 'Next') + '</span>' +
      '<span class="assessment__btn-icon">' + arrowRightSvg + '</span>' +
      '</button>';
  }

  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function resolveHeading(text) {
    if (!text) return text;
    return text.replace(/\{(\w+)\}/g, function (match, refId) {
      var ansVal = state.answers[refId] || '';
      if (!ansVal) return match;
      var refQ = getQuestion(refId);
      if (refQ && refQ.options) {
        for (var i = 0; i < refQ.options.length; i++) {
          if (refQ.options[i].value === ansVal) return refQ.options[i].label;
        }
      }
      return ansVal;
    });
  }

  function renderSelector(q) {
    var html = '<div class="assessment__inner assessment__slide-enter">';

    if (q.showBack !== false && state.history.length > 0) {
      html += renderBackButton();
    }

    html += '<div class="assessment__question-group">';

    var heading = q.dynamicHeading ? resolveHeading(q.heading) : q.heading;
    if (heading) {
      html += '<h1 class="assessment__heading">' + heading + '</h1>';
    }
    if (q.subheading) {
      html += '<p class="assessment__subheading">' + q.subheading + '</p>';
    }

    if (q.bulletPoints && q.bulletPoints.length > 0) {
      html += '<ul class="assessment__bullets">';
      for (var b = 0; b < q.bulletPoints.length; b++) {
        html += '<li>' + escapeHtml(q.bulletPoints[b]) + '</li>';
      }
      html += '</ul>';
    }

    if (q.headingAfter) {
      html += '<h1 class="assessment__heading">' + q.headingAfter + '</h1>';
    }

    var savedAnswer = state.answers[q.id] || null;
    html += '<div class="assessment__options">';
    for (var i = 0; i < q.options.length; i++) {
      var opt = q.options[i];
      var hasSubtext = q.type === 'selector-subtext' && opt.subtext;
      var isSelected = savedAnswer === opt.value;
      html += '<label class="assessment__option' + (isSelected ? ' is-selected' : '') + '" data-action="select-option" data-value="' + escapeHtml(opt.value) + '" data-next="' + escapeHtml(opt.next || q.next || '') + '">';
      html += '<input type="radio" class="assessment__option-input" name="assessment_q" value="' + escapeHtml(opt.value) + '"' + (isSelected ? ' checked' : '') + '>';
      html += '<span class="assessment__option-label">' + escapeHtml(opt.label) + '</span>';
      if (hasSubtext) {
        html += '<span class="assessment__option-subtext">' + escapeHtml(opt.subtext) + '</span>';
      }
      html += '</label>';
      if (isSelected) {
        state.selectedOption = opt.value;
      }
    }
    html += '</div>';
    html += '</div>';

    if (q.textLink) {
      html += '<a class="assessment__text-link" href="' + escapeHtml(q.textLink.url || '#') + '">' + escapeHtml(q.textLink.label) + '</a>';
    }

    if (q.showButton) {
      var btnDisabled = !savedAnswer;
      html += '<p class="assessment__error" data-assessment-error role="alert" aria-live="polite" style="display:none;"></p>';
      html += renderPrimaryButton(q.buttonLabel || 'Next', btnDisabled, 'submit-selector');
    }

    html += '</div>';
    return html;
  }

  function renderTextarea(q) {
    var html = '<div class="assessment__inner assessment__slide-enter">';

    if (q.showBack !== false && state.history.length > 0) {
      html += renderBackButton();
    }

    html += '<div class="assessment__question-group">';

    var heading = q.dynamicHeading ? resolveHeading(q.heading) : q.heading;
    if (heading) {
      html += '<h1 class="assessment__heading">' + heading + '</h1>';
    }

    if (q.bulletPoints && q.bulletPoints.length > 0) {
      html += '<ul class="assessment__bullets">';
      for (var i = 0; i < q.bulletPoints.length; i++) {
        html += '<li>' + escapeHtml(q.bulletPoints[i]) + '</li>';
      }
      html += '</ul>';
    }

    if (q.subheading) {
      html += '<p class="assessment__subheading">' + q.subheading + '</p>';
    }

    html += '<div class="assessment__field-group">';
    if (q.required) {
      html += '<span class="assessment__field-required">Required*</span>';
    }
    html += '<textarea class="assessment__textarea" placeholder="' + escapeHtml(q.placeholder || 'Start from here') + '" data-input="textarea"' + (q.required ? ' required' : '') + '>' + escapeHtml(state.answers[q.id] || '') + '</textarea>';
    html += '</div>';
    html += '</div>';

    html += renderPrimaryButton(q.buttonLabel || 'Confirm', q.required && !state.answers[q.id], 'submit-textarea');

    html += '</div>';
    return html;
  }

  function renderMultiselectTextarea(q) {
    var savedMeds = (state.answers[q.id] || '').split(',').filter(Boolean);
    var savedCondition = state.answers[q.id + '_condition'] || '';
    var html = '<div class="assessment__inner assessment__slide-enter">';

    if (q.showBack !== false && state.history.length > 0) {
      html += renderBackButton();
    }

    html += '<div class="assessment__question-group">';
    if (q.heading) {
      html += '<h1 class="assessment__heading">' + escapeHtml(q.heading) + '</h1>';
    }
    html += '<div class="assessment__options assessment__options--multiselect">';
    for (var i = 0; i < q.options.length; i++) {
      var opt = q.options[i];
      var checked = savedMeds.indexOf(opt.value) !== -1;
      html += '<label class="assessment__option' + (checked ? ' is-selected' : '') + ' assessment__option--checkbox" data-action="multiselect-option" data-value="' + escapeHtml(opt.value) + '">';
      html += '<input type="checkbox" class="assessment__option-input" value="' + escapeHtml(opt.value) + '"' + (checked ? ' checked' : '') + '>';
      html += '<span class="assessment__option-label">' + escapeHtml(opt.label) + '</span>';
      html += '</label>';
    }
    html += '</div>';

    if (q.heading2) {
      html += '<h1 class="assessment__heading">' + escapeHtml(q.heading2) + '</h1>';
    }
    html += '<div class="assessment__field-group">';
    html += '<span class="assessment__field-required">Required*</span>';
    html += '<textarea class="assessment__textarea" placeholder="' + escapeHtml(q.placeholder || 'Start from here') + '" data-input="multiselect-condition">' + escapeHtml(savedCondition) + '</textarea>';
    html += '</div>';
    html += '</div>';

    html += '<p class="assessment__error" data-assessment-multiselect-error role="alert" aria-live="polite" style="display:none;"></p>';
    html += renderPrimaryButton(q.buttonLabel || 'Next', false, 'submit-multiselect-textarea');
    html += '</div>';
    return html;
  }

  /** Comma-separated multiselect with optional exclusive "none" value (clears others when checked; others clear none). */
  function renderMultiselectSelector(q) {
    var saved = (state.answers[q.id] || '').split(',').filter(Boolean);
    var savedSet = {};
    for (var s = 0; s < saved.length; s++) savedSet[saved[s]] = true;
    var html = '<div class="assessment__inner assessment__slide-enter">';

    if (q.showBack !== false && state.history.length > 0) {
      html += renderBackButton();
    }

    html += '<div class="assessment__question-group">';
    var heading = q.dynamicHeading ? resolveHeading(q.heading) : q.heading;
    if (heading) {
      html += '<h1 class="assessment__heading">' + heading + '</h1>';
    }
    if (q.subheading) {
      html += '<p class="assessment__subheading">' + escapeHtml(q.subheading) + '</p>';
    }
    html += '<div class="assessment__options assessment__options--multiselect assessment__options--multiselect-selector">';
    for (var i = 0; i < q.options.length; i++) {
      var opt = q.options[i];
      var checked = !!savedSet[opt.value];
      html += '<label class="assessment__option' + (checked ? ' is-selected' : '') + ' assessment__option--checkbox" data-action="multiselect-selector-option" data-value="' + escapeHtml(opt.value) + '">';
      html += '<input type="checkbox" class="assessment__option-input" value="' + escapeHtml(opt.value) + '"' + (checked ? ' checked' : '') + '>';
      html += '<span class="assessment__option-label">' + escapeHtml(opt.label) + '</span>';
      html += '</label>';
    }
    html += '</div></div>';

    var btnDisabled = saved.length === 0;
    html += '<p class="assessment__error" data-assessment-multiselect-selector-error role="alert" aria-live="polite" style="display:none;"></p>';
    html += renderPrimaryButton(q.buttonLabel || 'Next', btnDisabled, 'submit-multiselect-selector');
    html += '</div>';
    return html;
  }

  function renderBasicInfo(q) {
    var html = '<div class="assessment__inner assessment__slide-enter">';

    if (q.showBack !== false && state.history.length > 0) {
      html += renderBackButton();
    }

    html += '<div class="assessment__question-group">';

    if (q.heading) {
      html += '<h1 class="assessment__heading">' + escapeHtml(q.heading) + '</h1>';
    }

    html += '<div class="assessment__basic-info-fields">';
    for (var i = 0; i < q.fields.length; i++) {
      var f = q.fields[i];
      var saved = state.answers[f.key] || '';
      var halfClass = f.half ? ' assessment__basic-info-field--half' : '';
      html += '<div class="assessment__basic-info-field' + halfClass + '">';
      html += '<label class="assessment__field-label">' + escapeHtml(f.label);
      if (f.required) html += ' <span class="assessment__field-required-tag">(Required)</span>';
      html += '</label>';
      if (f.type === 'dob') {
        var savedDay = '', savedMonth = '', savedYear = '';
        if (saved) {
          var dobParts = saved.split('-');
          savedYear = dobParts[0] || '';
          savedMonth = dobParts[1] || '';
          savedDay = dobParts[2] || '';
        }
        html += '<div class="assessment__dob-selects">';
        html += '<select class="assessment__input assessment__dob-select" data-dob-key="' + escapeHtml(f.key) + '" data-dob-part="day">';
        html += '<option value="">Day</option>';
        for (var d = 1; d <= 31; d++) {
          var dStr = d < 10 ? '0' + d : '' + d;
          html += '<option value="' + dStr + '"' + (savedDay === dStr ? ' selected' : '') + '>' + d + '</option>';
        }
        html += '</select>';
        var dobMonths = ['January','February','March','April','May','June','July','August','September','October','November','December'];
        html += '<select class="assessment__input assessment__dob-select" data-dob-key="' + escapeHtml(f.key) + '" data-dob-part="month">';
        html += '<option value="">Month</option>';
        for (var m = 0; m < 12; m++) {
          var mStr = (m + 1) < 10 ? '0' + (m + 1) : '' + (m + 1);
          html += '<option value="' + mStr + '"' + (savedMonth === mStr ? ' selected' : '') + '>' + dobMonths[m] + '</option>';
        }
        html += '</select>';
        var dobCurrentYear = new Date().getFullYear();
        html += '<select class="assessment__input assessment__dob-select" data-dob-key="' + escapeHtml(f.key) + '" data-dob-part="year">';
        html += '<option value="">Year</option>';
        for (var y = dobCurrentYear - 18; y >= 1924; y--) {
          html += '<option value="' + y + '"' + (savedYear === String(y) ? ' selected' : '') + '>' + y + '</option>';
        }
        html += '</select>';
        html += '</div>';
      } else {
        html += '<input type="' + (f.type || 'text') + '" class="assessment__input" placeholder="' + escapeHtml(f.placeholder || '') + '" data-field-key="' + escapeHtml(f.key) + '" value="' + escapeHtml(saved) + '"' + (f.required ? ' required' : '') + ' />';
      }
      html += '</div>';
    }
    html += '</div>';

    html += '</div>';

    html += '<p class="assessment__error" data-assessment-basic-info-error role="alert" aria-live="polite" style="display:none;"></p>';
    html += renderPrimaryButton(q.buttonLabel || 'Next', true, 'submit-basic-info');

    html += '</div>';
    return html;
  }

  function renderEmail(q) {
    var html = '<div class="assessment__inner assessment__slide-enter">';

    if (q.showBack !== false && state.history.length > 0) {
      html += renderBackButton();
    }

    html += '<div class="assessment__question-group">';

    if (q.heading) {
      html += '<h1 class="assessment__heading">' + q.heading + '</h1>';
    }

    html += '<div class="assessment__field-group">';
    if (q.required) {
      html += '<span class="assessment__field-required">Required*</span>';
    }
    html += '<input type="email" class="assessment__input" placeholder="' + escapeHtml(q.placeholder || '') + '" data-input="email" value="' + escapeHtml(state.answers[q.id] || '') + '"' + (q.required ? ' required' : '') + ' />';
    html += '</div>';
    html += '</div>';

    html += renderPrimaryButton(q.buttonLabel || 'Next', q.required && !state.answers[q.id], 'submit-email');

    html += '</div>';
    return html;
  }

  function renderLoading(q) {
    var html = '<div class="assessment__inner assessment__slide-enter">';
    html += '<div class="assessment__loading">';
    html += '<h1 class="assessment__loading-heading">' + escapeHtml(q.heading) + '</h1>';
    html += '<div class="assessment__loading-bar-wrap">';
    html += '<div class="assessment__loading-track">';
    html += '<div class="assessment__loading-fill"></div>';
    html += '</div>';
    if (q.subheading) {
      html += '<p class="assessment__loading-subtext">' + escapeHtml(q.subheading) + '</p>';
    }
    html += '</div>';
    html += '</div>';
    html += '</div>';
    return html;
  }

  function renderProductCard(q) {
    var p = q.product || {};
    var html = '<div class="assessment__inner assessment__slide-enter">';
    html += '<div class="assessment__product-section">';

    if (q.heading) {
      html += '<p class="assessment__product-title">' + escapeHtml(q.heading) + '</p>';
    }

    html += '<div class="assessment__product-card">';
    html += '<div class="assessment__product-header">';
    html += '<div class="assessment__product-names">';
    if (p.category) html += '<p class="assessment__product-category">' + escapeHtml(p.category) + '</p>';
    if (p.name) html += '<h2 class="assessment__product-name">' + escapeHtml(p.name) + '</h2>';
    html += '</div>';
    if (p.image) html += '<img class="assessment__product-image" src="' + assetUrlBase + escapeHtml(p.image) + '" alt="' + escapeHtml(p.name || '') + '">';
    html += '<div class="assessment__product-desc">';
    if (p.tagline) html += '<p class="assessment__product-desc-title">' + escapeHtml(p.tagline) + '</p>';
    if (p.description) html += '<p class="assessment__product-desc-text">' + escapeHtml(p.description) + '</p>';
    html += '</div>';
    html += '</div>';

    if (p.meta && p.meta.length > 0) {
      html += '<div class="assessment__product-meta">';
      for (var i = 0; i < p.meta.length; i++) {
        html += '<div class="assessment__product-meta-row">';
        html += '<span class="assessment__product-meta-label">' + escapeHtml(p.meta[i].label) + '</span>';
        html += '<span class="assessment__product-meta-value">' + escapeHtml(p.meta[i].value) + '</span>';
        html += '</div>';
      }
      html += '</div>';
    }

    html += renderPrimaryButton(q.buttonLabel || 'Continue', false, 'next');
    html += '</div>';

    if (q.seeAllLink) {
      html += '<p class="assessment__see-all">Prefer a different treatment? <a data-action="see-all">See all</a></p>';
    }

    html += '</div>';
    html += '</div>';
    return html;
  }

  function renderPricing(q) {
    var p = q.product || {};
    var tiers = q.tiers || [];
    var html = '<div class="assessment__inner assessment__slide-enter">';
    html += '<div class="assessment__pricing-section">';

    if (q.heading) {
      html += '<p class="assessment__product-title">' + escapeHtml(q.heading) + '</p>';
    }

    html += '<div class="assessment__pricing-card">';
    html += '<div class="assessment__pricing-card-header">';
    html += '<div class="assessment__pricing-card-info">';
    if (p.category) html += '<p class="assessment__product-category">' + escapeHtml(p.category) + '</p>';
    if (p.name) html += '<h2 class="assessment__product-name">' + escapeHtml(p.name) + '</h2>';
    html += '</div>';
    if (p.image) html += '<img class="assessment__pricing-card-image" src="' + assetUrlBase + escapeHtml(p.image) + '" alt="' + escapeHtml(p.name || '') + '">';
    html += '</div>';

    if (p.meta && p.meta.length > 0) {
      html += '<div class="assessment__product-meta">';
      for (var i = 0; i < p.meta.length; i++) {
        html += '<div class="assessment__product-meta-row">';
        html += '<span class="assessment__product-meta-label">' + escapeHtml(p.meta[i].label) + '</span>';
        html += '<span class="assessment__product-meta-value">' + escapeHtml(p.meta[i].value) + '</span>';
        html += '</div>';
      }
      html += '</div>';
    }
    html += '</div>';

    html += '<div class="assessment__pricing-tiers">';
    for (var t = 0; t < tiers.length; t++) {
      var tier = tiers[t];
      html += '<div class="assessment__pricing-tier" data-action="select-tier" data-index="' + t + '">';
      html += '<div class="assessment__pricing-tier-info">';
      html += '<p class="assessment__pricing-tier-duration">' + escapeHtml(tier.duration) + '</p>';
      html += '<p class="assessment__pricing-tier-qty">' + escapeHtml(tier.tablets) + '</p>';
      html += '</div>';
      html += '<div class="assessment__pricing-tier-price-wrap">';
      if (tier.badge) {
        html += '<span class="assessment__pricing-badge">' + escapeHtml(tier.badge) + '</span>';
      }
      html += '<div class="assessment__pricing-tier-price">';
      html += '<span class="assessment__pricing-amount">£' + escapeHtml(tier.price) + '</span>';
      html += '<span class="assessment__pricing-unit">' + escapeHtml(tier.perUnit || '/mo') + '</span>';
      html += '</div>';
      html += '</div>';
      html += '</div>';
    }
    html += '</div>';

    html += renderPrimaryButton(q.buttonLabel || 'Checkout', true, 'submit-pricing');

    if (q.seeAllLink) {
      html += '<p class="assessment__see-all">Prefer a different treatment? <a data-action="see-all">See all</a></p>';
    }

    html += '</div>';
    html += '</div>';
    return html;
  }

  function renderAgreement(q) {
    var html = '<div class="assessment__inner assessment__slide-enter">';

    if (q.showBack !== false && state.history.length > 0) {
      html += renderBackButton();
    }

    html += '<div class="assessment__question-group">';

    if (q.heading) {
      html += '<h1 class="assessment__heading">' + escapeHtml(q.heading) + '</h1>';
    }

    if (q.bulletPoints && q.bulletPoints.length > 0) {
      html += '<div class="assessment__agreement-points">';
      for (var i = 0; i < q.bulletPoints.length; i++) {
        var bp = q.bulletPoints[i];
        var pointInner =
          bp && typeof bp === 'object' && bp.html != null ? String(bp.html) : escapeHtml(String(bp));
        html += '<p class="assessment__agreement-point">• ' + pointInner + '</p>';
      }
      html += '</div>';
    }

    html += '<button type="button" class="assessment__btn-confirm" data-action="agreement-next">' +
      '<span>' + escapeHtml(q.buttonLabel || 'Confirm') + '</span>' +
      '<span class="assessment__btn-icon">' + arrowRightSvg + '</span>' +
      '</button>';

    html += '</div>';

    html += '</div>';
    return html;
  }

  function renderInfo(q) {
    var html = '<div class="assessment__inner assessment__slide-enter">';

    if (q.showBack !== false && state.history.length > 0) {
      html += renderBackButton();
    }

    html += '<div class="assessment__question-group">';

    if (q.quote) {
      html += '<div class="assessment__info-quote">';
      html += '<p class="assessment__info-quote-text">' + escapeHtml(q.quote) + '</p>';
      html += '</div>';
    }

    if (q.body) {
      html += '<p class="assessment__info-body">' + escapeHtml(q.body) + '</p>';
    }

    html += '</div>';

    html += renderPrimaryButton(q.buttonLabel || 'Got it', false, 'info-next');

    html += '</div>';
    return html;
  }

  function renderMessage(q) {
    var html = '<div class="assessment__inner assessment__slide-enter">';
    html += '<div class="assessment__loading">';
    html += '<h1 class="assessment__loading-heading">' + escapeHtml(q.heading) + '</h1>';
    if (q.subheading) {
      html += '<p class="assessment__loading-subtext">' + escapeHtml(q.subheading) + '</p>';
    }
    if (q.redirectUrl && !hasEmailParam()) {
      var delayMs = q.redirectDelay != null ? q.redirectDelay : 3000;
      var sec = Math.max(1, Math.ceil(delayMs / 1000));
      html += '<p class="assessment__loading-subtext assessment__redirect-countdown" aria-live="polite">Redirecting in <span data-redirect-seconds>' +
        sec +
        '</span>s…</p>';
    }
    if (q.buttonLabel) {
      var btnAction = q.buttonAction || 'restart';
      var btnLabel = q.buttonLabel;
      if (hasEmailParam() && btnAction === 'redirect-now') {
        btnAction = 'go-home';
        btnLabel = 'Return Home';
      }
      html += renderPrimaryButton(btnLabel, false, btnAction);
    }
    html += '</div>';
    html += '</div>';
    return html;
  }

  function renderComplete() {
    var html = '<div class="assessment__inner assessment__slide-enter">';
    html += '<div class="assessment__loading">';
    html += '<h1 class="assessment__loading-heading">Thank you for completing the assessment!</h1>';
    html += '<p class="assessment__loading-subtext">Our team will review your answers and be in touch shortly.</p>';
    html += renderPrimaryButton('Start Again', false, 'restart');
    html += '</div>';
    html += '</div>';
    return html;
  }

  /* ---- Weight slider ---- */

  function kgToStLb(kg) {
    var totalLbs = Math.round(kg * 2.20462);
    var st = Math.floor(totalLbs / 14);
    var lb = totalLbs % 14;
    return { st: st, lb: lb };
  }

  function stLbToKg(st, lb) {
    return Math.round((st * 14 + lb) * 0.453592);
  }

  function buildRulerTicks() {
    var styleEl = document.getElementById('gad-tick-style');
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = 'gad-tick-style';
      document.head.appendChild(styleEl);
    }
    styleEl.textContent =
      '.assessment__ruler-ticks { display: flex !important; align-items: flex-end !important; justify-content: space-between !important; height: 85px !important; width: 218px !important; visibility: visible !important; opacity: 1 !important; }' +
      '.assessment__ruler-tick { display: block !important; visibility: visible !important; width: 1.5px !important; height: 54px !important; background-color: #242E54 !important; flex-shrink: 0 !important; }' +
      '.assessment__ruler-tick.is-center { width: 2px !important; height: 85px !important; opacity: 1 !important; }' +
      '.assessment__ruler-tick.tick-fade-1 { opacity: 0.65 !important; }' +
      '.assessment__ruler-tick.tick-fade-2 { opacity: 0.50 !important; }' +
      '.assessment__ruler-tick.tick-fade-3 { opacity: 0.35 !important; }' +
      '.assessment__ruler-tick.tick-fade-4 { opacity: 0.20 !important; }' +
      '.assessment__ruler-tick.tick-fade-5 { opacity: 0.08 !important; }' +
      '.assessment__ruler-wrap { display: flex !important; visibility: visible !important; opacity: 1 !important; }' +
      '.assessment__ruler-labels { display: flex !important; visibility: visible !important; opacity: 1 !important; }';

    var ticks = '';
    for (var i = 0; i < 11; i++) {
      var isCenter = i === 5;
      var dist = Math.abs(i - 5);
      var cls = 'assessment__ruler-tick';
      if (isCenter) {
        cls += ' is-center';
      } else {
        cls += ' tick-fade-' + dist;
      }
      ticks += '<div class="' + cls + '"></div>';
    }
    return ticks;
  }

  function renderWeightSlider(q) {
    var html = '<div class="assessment__inner assessment__slide-enter">';

    if (q.showBack !== false && state.history.length > 0) {
      html += renderBackButton();
    }

    html += '<div class="assessment__question-group">';

    if (q.heading) {
      html += '<h1 class="assessment__heading">' + escapeHtml(q.heading) + '</h1>';
    }

    var savedKg = parseInt(state.answers[q.id], 10) || 75;
    var conv = kgToStLb(savedKg);
    var unit = state._weightUnit || 'stlb';

    html += '<div class="assessment__weight-content">';

    html += '<div class="assessment__weight-values">';

    html += '<div class="assessment__weight-stlb-and-box">';
    html += '<p class="assessment__weight-secondary" data-weight-secondary>' + conv.st + '<span class="assessment__weight-unit-sm">st</span> ' + conv.lb + '<span class="assessment__weight-unit-sm">lb</span></p>';
    html += '<div class="assessment__weight-box">';
    html += '<p class="assessment__weight-value" data-weight-value>' + savedKg + '<span class="assessment__weight-unit-lg">kg</span></p>';
    html += '</div>';
    html += '</div>';

    html += '<div class="assessment__ruler-wrap">';
    html += '<div class="assessment__ruler-ticks">';
    html += buildRulerTicks();
    html += '</div>';
    html += '<div class="assessment__ruler-labels" data-ruler-labels>';
    var lo = Math.max(35, savedKg - 5);
    var hi = Math.min(300, savedKg + 5);
    html += '<span>' + lo + '</span>';
    html += '<span>' + savedKg + '</span>';
    html += '<span>' + hi + '</span>';
    html += '</div>';
    html += '<input type="range" class="assessment__weight-range" data-input="weight-range" min="35" max="300" value="' + savedKg + '" step="1">';
    html += '</div>';

    html += '</div>';

    html += '</div>';
    html += '</div>';

    html += renderPrimaryButton(q.buttonLabel || 'Next', false, 'submit-weight');

    html += '</div>';
    return html;
  }

  /* ---- Height slider ---- */

  function cmToFtIn(cm) {
    var totalInches = Math.round(cm / 2.54);
    var ft = Math.floor(totalInches / 12);
    var inches = totalInches % 12;
    return { ft: ft, in: inches };
  }

  function renderHeightSlider(q) {
    var html = '<div class="assessment__inner assessment__slide-enter">';

    if (q.showBack !== false && state.history.length > 0) {
      html += renderBackButton();
    }

    html += '<div class="assessment__question-group">';

    if (q.heading) {
      html += '<h1 class="assessment__heading">' + escapeHtml(q.heading) + '</h1>';
    }

    var savedCm = parseInt(state.answers[q.id], 10) || 170;
    var conv = cmToFtIn(savedCm);
    var unit = state._heightUnit || 'ftin';

    html += '<div class="assessment__weight-content">';

    html += '<div class="assessment__weight-values">';

    html += '<div class="assessment__weight-stlb-and-box">';
    html += '<p class="assessment__weight-secondary" data-height-secondary>' + conv.ft + '<span class="assessment__weight-unit-sm">ft</span> ' + conv.in + '<span class="assessment__weight-unit-sm">in</span></p>';
    html += '<div class="assessment__weight-box">';
    html += '<p class="assessment__weight-value" data-height-value>' + savedCm + '<span class="assessment__weight-unit-lg">cm</span></p>';
    html += '</div>';
    html += '</div>';

    html += '<div class="assessment__ruler-wrap">';
    html += '<div class="assessment__ruler-ticks">';
    html += buildRulerTicks();
    html += '</div>';
    html += '<div class="assessment__ruler-labels" data-height-ruler-labels>';
    var lo = Math.max(100, savedCm - 5);
    var hi = Math.min(220, savedCm + 5);
    html += '<span>' + lo + '</span>';
    html += '<span>' + savedCm + '</span>';
    html += '<span>' + hi + '</span>';
    html += '</div>';
    html += '<input type="range" class="assessment__weight-range" data-input="height-range" min="100" max="220" value="' + savedCm + '" step="1">';
    html += '</div>';

    html += '</div>';

    html += '</div>';
    html += '</div>';

    html += renderPrimaryButton(q.buttonLabel || 'Next', false, 'submit-height');

    html += '</div>';
    return html;
  }

  /* ---- Main render ---- */

  function render() {
    if (!container || !config) return;

    clearRedirectCountdown();

    var q = getQuestion(state.currentId);
    if (!q) {
      container.innerHTML = renderComplete();
      animateIn();
      bindEvents();
      return;
    }

    var html = '';
    switch (q.type) {
      case 'selector':
      case 'selector-subtext':
        html = renderSelector(q);
        break;
      case 'textarea':
        html = renderTextarea(q);
        break;
      case 'loading':
        html = renderLoading(q);
        break;
      case 'product-card':
        html = renderProductCard(q);
        break;
      case 'pricing':
        html = renderPricing(q);
        break;
      case 'message':
        html = renderMessage(q);
        break;
      case 'agreement':
        html = renderAgreement(q);
        break;
      case 'info':
        html = renderInfo(q);
        break;
      case 'weight-slider':
        html = renderWeightSlider(q);
        break;
      case 'height-slider':
        html = renderHeightSlider(q);
        break;
      case 'basic-info':
        html = renderBasicInfo(q);
        break;
      case 'email':
        html = renderEmail(q);
        break;
      case 'multiselect-textarea':
        html = renderMultiselectTextarea(q);
        break;
      case 'multiselect-selector':
        html = renderMultiselectSelector(q);
        break;
      default:
        html = renderSelector(q);
    }

    var progressHtml = '';
    if (state.history.length > 0 && q.type !== 'loading' && q.type !== 'product-card' && q.type !== 'pricing' && q.type !== 'message') {
      progressHtml = renderProgressBar();
    }
    container.innerHTML = progressHtml + html;
    animateIn();
    bindEvents();

    if (q.type === 'loading') {
      var duration = q.duration || 3000;
      var loadStyleEl = document.getElementById('gad-loading-style');
      if (!loadStyleEl) {
        loadStyleEl = document.createElement('style');
        loadStyleEl.id = 'gad-loading-style';
        document.head.appendChild(loadStyleEl);
      }

      var loadPct = 0;
      var stepMs = 50;
      var stepInc = 100 / (duration / stepMs);

      function updateLoadBar() {
        loadStyleEl.textContent =
          '.assessment__loading { display: flex !important; visibility: visible !important; opacity: 1 !important; }' +
          '.assessment__loading-bar-wrap { display: flex !important; visibility: visible !important; opacity: 1 !important; }' +
          '.assessment__loading-track { display: block !important; visibility: visible !important; opacity: 1 !important; width: 100% !important; height: 5px !important; background: #e8eaed !important; border-radius: 3px !important; overflow: hidden !important; }' +
          '.assessment__loading-fill { display: block !important; visibility: visible !important; opacity: 1 !important; height: 100% !important; background: #033038 !important; border-radius: 3px !important; width: ' + Math.min(Math.round(loadPct), 100) + '% !important; }';
      }

      updateLoadBar();

      var loadInterval = setInterval(function () {
        loadPct += stepInc;
        if (loadPct >= 100) {
          loadPct = 100;
          clearInterval(loadInterval);
        }
        updateLoadBar();
      }, stepMs);

      function tryAdvance() {
        if (state.currentId !== q.id) return;

        if (state._apiSubmitPending) {
          setTimeout(tryAdvance, 300);
          return;
        }

        clearInterval(loadInterval);

        if (state._apiSubmitError) {
          goBack();
          setTimeout(function () {
            var errEl = container.querySelector('[data-assessment-api-error]');
            if (!errEl) {
              errEl = document.createElement('p');
              errEl.className = 'assessment__error assessment__api-error';
              errEl.setAttribute('data-assessment-api-error', '');
              errEl.setAttribute('role', 'alert');
              errEl.setAttribute('aria-live', 'polite');
              var inner = container.querySelector('.assessment__inner');
              if (inner) inner.appendChild(errEl);
            }
            errEl.textContent = state._apiSubmitError;
            errEl.style.display = 'block';
            state._apiSubmitError = null;
          }, 100);
          return;
        }

        goTo(q.next);
      }

      setTimeout(function () {
        clearInterval(loadInterval);
        tryAdvance();
      }, duration);
    }
  }

  function animateIn() {
    var el = container.querySelector('.assessment__slide-enter');
    if (!el) return;
    requestAnimationFrame(function () {
      el.classList.remove('assessment__slide-enter');
      el.classList.add('assessment__slide-active');
    });
  }

  /* ---- Event binding ---- */

  function bindEvents() {
    var q = getQuestion(state.currentId);
    if (!q) {
      var restartBtn = container.querySelector('[data-action="restart"]');
      if (restartBtn) {
        restartBtn.addEventListener('click', function () {
          clearState();
          state.currentId = config.questions[0].id;
          saveState();
          render();
        });
      }
      return;
    }

    var backBtn = container.querySelector('[data-action="back"]');
    if (backBtn) {
      backBtn.addEventListener('click', goBack);
    }

    if (q.type === 'selector' || q.type === 'selector-subtext') {
      var options = container.querySelectorAll('[data-action="select-option"]');
      for (var i = 0; i < options.length; i++) {
        (function (opt) {
          opt.addEventListener('click', function () {
            var value = opt.getAttribute('data-value');
            var next = opt.getAttribute('data-next');
            selectAnswer(q.id, value);

            var all = container.querySelectorAll('.assessment__option');
            for (var j = 0; j < all.length; j++) all[j].classList.remove('is-selected');
            opt.classList.add('is-selected');

            if (q.showButton) {
              state.selectedOption = value;
              var btn = container.querySelector('[data-action="submit-selector"]');
              if (btn) {
                btn.classList.remove('is-disabled');
                btn.disabled = false;
                btn.setAttribute('data-next', next || q.next || '');
              }
              var errEl = container.querySelector('[data-assessment-error]');
              if (errEl) { errEl.style.display = 'none'; errEl.textContent = ''; }
            } else {
              setTimeout(function () {
                goTo(next || q.next);
              }, 300);
            }
          });
        })(options[i]);
      }

      var submitSel = container.querySelector('[data-action="submit-selector"]');
      var prevAnswer = state.answers[q.id] || null;
      if (submitSel && prevAnswer) {
        for (var si = 0; si < q.options.length; si++) {
          if (q.options[si].value === prevAnswer) {
            submitSel.setAttribute('data-next', q.options[si].next || q.next || '');
            break;
          }
        }
      }
      if (submitSel) {
        submitSel.addEventListener('click', function () {
          var next = submitSel.getAttribute('data-next') || q.next;
          var hasSelection = state.selectedOption || state.answers[q.id];
          if (!hasSelection) {
            var errEl = container.querySelector('[data-assessment-error]');
            if (errEl) {
              errEl.textContent = 'Please select an option.';
              errEl.style.display = 'block';
            }
            return;
          }
          if (next === 'login') {
            var loginUrl = (config.loginUrl != null && config.loginUrl !== '') ? config.loginUrl : '/account/login';
            window.location.href = loginUrl;
            return;
          }
          if (q.id === 'q4b') {
            var ageAns = state.answers['q4'];
            var bpCheckAns = state.selectedOption || state.answers[q.id];
            if (ageAns === '70-plus' && bpCheckAns === 'no') {
              next = 'not-eligible';
            } else if (bpCheckAns === 'no') {
              next = 'q4a';
            }
          }
          if (q.id === 'q4c') {
            var q4bAns = state.answers['q4b'];
            var q4cAns = state.selectedOption || state.answers[q.id];
            if (q4bAns === 'no' && q4cAns === 'bp-normal') {
              next = 'not-eligible';
            }
          }
          goTo(next);
        });
      }
    }

    if (q.type === 'multiselect-textarea') {
      var multiselectOptions = container.querySelectorAll('[data-action="multiselect-option"]');
      var conditionInput = container.querySelector('[data-input="multiselect-condition"]');
      var submitBtn = container.querySelector('[data-action="submit-multiselect-textarea"]');
      var errEl = container.querySelector('[data-assessment-multiselect-error]');

      function updateMultiselectState() {
        var checked = [];
        for (var i = 0; i < multiselectOptions.length; i++) {
          var cb = multiselectOptions[i].querySelector('input[type="checkbox"]');
          if (cb && cb.checked) checked.push(cb.value);
        }
        selectAnswer(q.id, checked.join(','));
        var condition = conditionInput ? conditionInput.value.trim() : '';
        selectAnswer(q.id + '_condition', condition);
        if (submitBtn) {
          var valid = checked.length > 0 && condition.length > 0;
          submitBtn.disabled = !valid;
          submitBtn.classList.toggle('is-disabled', !valid);
        }
        if (errEl) { errEl.style.display = 'none'; errEl.textContent = ''; }
      }

      for (var m = 0; m < multiselectOptions.length; m++) {
        (function (label) {
          var cb = label.querySelector('input[type="checkbox"]');
          if (cb) {
            cb.addEventListener('change', function () {
              label.classList.toggle('is-selected', cb.checked);
              updateMultiselectState();
            });
          }
        })(multiselectOptions[m]);
      }
      if (conditionInput) {
        conditionInput.addEventListener('input', function () { updateMultiselectState(); });
      }
      if (submitBtn) {
        submitBtn.addEventListener('click', function () {
          var meds = (state.answers[q.id] || '').split(',').filter(Boolean);
          var condition = (state.answers[q.id + '_condition'] || '').trim();
          if (meds.length === 0) {
            if (errEl) { errEl.textContent = 'Please select at least one medication.'; errEl.style.display = 'block'; }
            return;
          }
          if (!condition) {
            if (errEl) { errEl.textContent = 'Please tell us what condition you are using it to treat.'; errEl.style.display = 'block'; }
            return;
          }
          saveState();
          goTo(q.next);
        });
      }
      updateMultiselectState();
    }

    if (q.type === 'multiselect-selector') {
      var mselOpts = container.querySelectorAll('[data-action="multiselect-selector-option"]');
      var mselSubmit = container.querySelector('[data-action="submit-multiselect-selector"]');
      var mselErr = container.querySelector('[data-assessment-multiselect-selector-error]');
      var exclArr = q.exclusiveValues || [];
      var exclMap = {};
      for (var ei = 0; ei < exclArr.length; ei++) exclMap[exclArr[ei]] = true;

      function orderedSelectionString() {
        var checked = {};
        for (var i = 0; i < mselOpts.length; i++) {
          var cbin = mselOpts[i].querySelector('input[type="checkbox"]');
          if (cbin && cbin.checked) checked[cbin.value] = true;
        }
        var parts = [];
        for (var o = 0; o < q.options.length; o++) {
          var v = q.options[o].value;
          if (checked[v]) parts.push(v);
        }
        return parts.join(',');
      }

      function syncMultiselectSelectorLabels() {
        for (var si = 0; si < mselOpts.length; si++) {
          var box = mselOpts[si].querySelector('input[type="checkbox"]');
          if (box) mselOpts[si].classList.toggle('is-selected', box.checked);
        }
      }

      function updateMultiselectSelectorState() {
        var str = orderedSelectionString();
        selectAnswer(q.id, str);
        var cnt = str ? str.split(',').filter(Boolean).length : 0;
        if (mselSubmit) {
          mselSubmit.disabled = cnt === 0;
          mselSubmit.classList.toggle('is-disabled', cnt === 0);
        }
        if (mselErr) { mselErr.style.display = 'none'; mselErr.textContent = ''; }
      }

      for (var ms = 0; ms < mselOpts.length; ms++) {
        (function (labelEl) {
          var cb = labelEl.querySelector('input[type="checkbox"]');
          if (!cb) return;
          labelEl.addEventListener('click', function (e) {
            e.preventDefault();
            cb.checked = !cb.checked;
            if (cb.checked && exclMap[cb.value]) {
              for (var k = 0; k < mselOpts.length; k++) {
                var other = mselOpts[k].querySelector('input[type="checkbox"]');
                if (other && other !== cb) other.checked = false;
              }
            } else if (cb.checked && !exclMap[cb.value]) {
              for (var n = 0; n < mselOpts.length; n++) {
                var ex = mselOpts[n].querySelector('input[type="checkbox"]');
                if (ex && exclMap[ex.value]) ex.checked = false;
              }
            }
            syncMultiselectSelectorLabels();
            updateMultiselectSelectorState();
          });
        })(mselOpts[ms]);
      }

      if (mselSubmit) {
        mselSubmit.addEventListener('click', function () {
          var str = orderedSelectionString();
          if (!str || !str.split(',').filter(Boolean).length) {
            if (mselErr) {
              mselErr.textContent = 'Please select at least one option.';
              mselErr.style.display = 'block';
            }
            return;
          }
          selectAnswer(q.id, str);
          var vals = str.split(',').filter(Boolean);
          var nextId = q.next || 'q6';

          if (q.id === 'q5') {
            var pde5 = { sildenafil: true, tadalafil: true, vardenafil: true, avanafil: true };
            var hi = 0;
            for (; hi < vals.length; hi++) {
              if (pde5[vals[hi]]) {
                nextId = 'not-eligible';
                break;
              }
            }
            if (nextId !== 'not-eligible') {
              if (vals.indexOf('other') !== -1) nextId = 'q5b';
              else if (vals.indexOf('lactose') !== -1) nextId = 'q5a';
              else nextId = 'q6';
            }
          }

          if (q.id === 'q7') {
            var inelig = { 'refrain-activity': true, 'heart-attack': true, 'optic-neuropathy': true, 'cardiovascular-disease': true };
            var q7hit = false;
            for (var vi = 0; vi < vals.length; vi++) {
              if (inelig[vals[vi]]) { nextId = 'not-eligible'; q7hit = true; break; }
            }
            if (!q7hit) {
              var q7route = [
                { v: 'chest-pain', n: 'q7a' },
                { v: 'liver-kidney', n: 'q8' },
                { v: 'organ-transplant', n: 'q9' },
                { v: 'retinal-disorder', n: 'q10' },
                { v: 'irregular-heartbeat', n: 'q11' },
                { v: 'blood-disorder', n: 'q11a' },
                { v: 'penile-deformity', n: 'q14' },
                { v: 'blood-pressure', n: 'q15' }
              ];
              var q7matched = [];
              for (var ri = 0; ri < q7route.length; ri++) {
                if (vals.indexOf(q7route[ri].v) !== -1) q7matched.push(q7route[ri].n);
              }
              if (q7matched.length > 0) {
                nextId = q7matched[0];
                state._q7Queue = q7matched.slice(1);
              } else {
                state._q7Queue = [];
              }
            }
          }

          if (q.id === 'q15') {
            var q15inelig = { 'nitrates-poppers': true };
            var q15hit = false;
            for (var pi = 0; pi < vals.length; pi++) {
              if (q15inelig[vals[pi]]) { nextId = 'not-eligible'; q15hit = true; break; }
            }
            if (!q15hit) {
              var q15route = [
                { v: 'cyp-inhibitors', n: 'q15a' },
                { v: 'ssri', n: 'q16' },
                { v: 'hiv-protease', n: 'q18b' },
                { v: 'alpha-blockers', n: 'q18' },
                { v: 'calcium-channel', n: 'q19' },
                { v: 'kinase-inhibitors', n: 'q20' }
              ];
              var q15matched = [];
              for (var qi = 0; qi < q15route.length; qi++) {
                if (vals.indexOf(q15route[qi].v) !== -1) q15matched.push(q15route[qi].n);
              }
              if (q15matched.length > 0) {
                nextId = q15matched[0];
                state._q15Queue = q15matched.slice(1);
              } else {
                state._q15Queue = [];
              }
            }
          }

          if (q.id === 'q21') {
            var q21route = [
              { v: 'viagra', n: 'q21a' },
              { v: 'cialis', n: 'q22' },
              { v: 'levitra', n: 'q23' },
              { v: 'spedra', n: 'q24' },
              { v: 'penile-pumps', n: 'q25' },
              { v: 'penile-injections', n: 'q26' },
              { v: 'herbal', n: 'q28' },
              { v: 'other', n: 'q29' }
            ];
            var q21matched = [];
            for (var ti = 0; ti < q21route.length; ti++) {
              if (vals.indexOf(q21route[ti].v) !== -1) q21matched.push(q21route[ti].n);
            }
            if (q21matched.length > 0) {
              nextId = q21matched[0];
              state._q21Queue = q21matched.slice(1);
            } else {
              state._q21Queue = [];
            }
          }

          saveState();
          goTo(nextId);
        });
      }
      syncMultiselectSelectorLabels();
      updateMultiselectSelectorState();
    }

    if (q.type === 'textarea') {
      var ta = container.querySelector('[data-input="textarea"]');
      var submitTa = container.querySelector('[data-action="submit-textarea"]');
      if (ta && submitTa) {
        ta.addEventListener('input', function () {
          var val = ta.value.trim();
          selectAnswer(q.id, val);
          if (q.required) {
            submitTa.disabled = !val;
            submitTa.classList.toggle('is-disabled', !val);
          }
        });
        submitTa.addEventListener('click', function () {
          if (!q.required || (state.answers[q.id] && state.answers[q.id].trim())) {
            var taNext = q.next;
            if (q.id === 'q5b') {
              var q5raw = state.answers['q5'] || '';
              var q5parts = q5raw.split(',').filter(Boolean);
              if (q5parts.indexOf('lactose') !== -1) taNext = 'q5a';
            }
            goTo(taNext);
          }
        });
      }
    }

    if (q.type === 'basic-info') {
      var biInputs = container.querySelectorAll('[data-field-key], [data-dob-part]');
      var biSubmit = container.querySelector('[data-action="submit-basic-info"]');
      var biErr = container.querySelector('[data-assessment-basic-info-error]');

      function validateBasicInfo() {
        var allValid = true;
        for (var i = 0; i < q.fields.length; i++) {
          var f = q.fields[i];
          if (f.type === 'dob') {
            var dayEl = container.querySelector('[data-dob-key="' + f.key + '"][data-dob-part="day"]');
            var monthEl = container.querySelector('[data-dob-key="' + f.key + '"][data-dob-part="month"]');
            var yearEl = container.querySelector('[data-dob-key="' + f.key + '"][data-dob-part="year"]');
            var dobDay = dayEl ? dayEl.value : '';
            var dobMonth = monthEl ? monthEl.value : '';
            var dobYear = yearEl ? yearEl.value : '';
            if (dobDay && dobMonth && dobYear) {
              state.answers[f.key] = dobYear + '-' + dobMonth + '-' + dobDay;
            } else {
              state.answers[f.key] = '';
            }
            if (f.required && (!dobDay || !dobMonth || !dobYear)) allValid = false;
          } else {
            var inp = container.querySelector('[data-field-key="' + f.key + '"]');
            if (!inp) continue;
            var val = inp.value.trim();
            state.answers[f.key] = val;
            if (f.required && !val) allValid = false;
            if (f.type === 'email' && val && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) allValid = false;
          }
        }
        if (biSubmit) {
          biSubmit.disabled = !allValid;
          biSubmit.classList.toggle('is-disabled', !allValid);
        }
        if (biErr) { biErr.style.display = 'none'; biErr.textContent = ''; }
        return allValid;
      }

      for (var bi = 0; bi < biInputs.length; bi++) {
        biInputs[bi].addEventListener('input', validateBasicInfo);
      }
      if (biSubmit) {
        biSubmit.addEventListener('click', function () {
          if (!validateBasicInfo()) {
            if (biErr) { biErr.textContent = 'Please fill in all required fields.'; biErr.style.display = 'block'; }
            return;
          }
          saveState();
          goTo(q.next);
        });
      }
      validateBasicInfo();
    }

    if (q.type === 'email') {
      var emailInput = container.querySelector('[data-input="email"]');
      var submitEmail = container.querySelector('[data-action="submit-email"]');
      if (emailInput && submitEmail) {
        emailInput.addEventListener('input', function () {
          var val = emailInput.value.trim();
          selectAnswer(q.id, val);
          var valid = val && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
          if (q.required) {
            submitEmail.disabled = !valid;
            submitEmail.classList.toggle('is-disabled', !valid);
          }
        });
        submitEmail.addEventListener('click', function () {
          var val = state.answers[q.id] || '';
          if (!q.required || (val && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val))) {
            goTo(q.next);
          }
        });
      }
    }

    if (q.type === 'product-card') {
      var nextBtn = container.querySelector('[data-action="next"]');
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goTo(q.next);
        });
      }
    }

    if (q.type === 'agreement') {
      var agreementBtn = container.querySelector('[data-action="agreement-next"]');
      if (agreementBtn) {
        agreementBtn.addEventListener('click', function () {
          goTo(q.next);
        });
      }
    }

    if (q.type === 'info') {
      var infoBtn = container.querySelector('[data-action="info-next"]');
      if (infoBtn) {
        infoBtn.addEventListener('click', function () {
          goTo(q.next);
        });
      }
    }

    if (q.type === 'message') {
      if (q.redirectUrl && !hasEmailParam()) {
        var delayMs = q.redirectDelay != null ? q.redirectDelay : 3000;
        var totalSec = Math.max(1, Math.ceil(delayMs / 1000));
        var secEl = container.querySelector('[data-redirect-seconds]');
        var remaining = totalSec;
        redirectCountdownInterval = setInterval(function () {
          remaining -= 1;
          if (secEl) secEl.textContent = String(Math.max(0, remaining));
          if (remaining <= 0) {
            if (redirectCountdownInterval) {
              clearInterval(redirectCountdownInterval);
              redirectCountdownInterval = null;
            }
          }
        }, 1000);
        redirectCountdownTimer = setTimeout(function () {
          clearRedirectCountdown();
          window.location.href = q.redirectUrl;
        }, delayMs);
      }
      var redirectNowBtn = container.querySelector('[data-action="redirect-now"]');
      if (redirectNowBtn && q.redirectUrl && !hasEmailParam()) {
        redirectNowBtn.addEventListener('click', function () {
          clearRedirectCountdown();
          window.location.href = q.redirectUrl;
        });
      }
      var goHomeBtn = container.querySelector('[data-action="go-home"]');
      if (goHomeBtn) {
        goHomeBtn.addEventListener('click', function () {
          clearRedirectCountdown();
          window.location.href = window.location.origin + '/';
        });
      }
      var msgBtn = container.querySelector('[data-action="restart"]');
      if (msgBtn) {
        msgBtn.addEventListener('click', function () {
          clearState();
          state.currentId = config.questions[0].id;
          saveState();
          render();
        });
      }
    }

    if (q.type === 'pricing') {
      var tierEls = container.querySelectorAll('[data-action="select-tier"]');
      var pricingSubmit = container.querySelector('[data-action="submit-pricing"]');
      for (var t = 0; t < tierEls.length; t++) {
        (function (el) {
          el.addEventListener('click', function () {
            var idx = parseInt(el.getAttribute('data-index'), 10);
            state.selectedTier = idx;
            var tiers = q.tiers || [];
            if (tiers[idx]) {
              selectAnswer(q.id, tiers[idx].duration);
            }
            var all = container.querySelectorAll('.assessment__pricing-tier');
            for (var j = 0; j < all.length; j++) all[j].classList.remove('is-selected');
            el.classList.add('is-selected');
            if (pricingSubmit) {
              pricingSubmit.disabled = false;
              pricingSubmit.classList.remove('is-disabled');
            }
          });
        })(tierEls[t]);
      }
      if (pricingSubmit) {
        pricingSubmit.addEventListener('click', function () {
          if (state.selectedTier !== null && state.selectedTier !== undefined) {
            goTo(q.next);
          }
        });
      }
    }

    if (q.type === 'weight-slider') {
      var weightRange = container.querySelector('[data-input="weight-range"]');
      var weightValueEl = container.querySelector('[data-weight-value]');
      var weightSecEl = container.querySelector('[data-weight-secondary]');
      var rulerLabels = container.querySelector('[data-ruler-labels]');
      var _wRafId = null;

      function updateWeightDisplay(kg) {
        var c = kgToStLb(kg);
        if (weightValueEl) {
          weightValueEl.innerHTML = kg + '<span class="assessment__weight-unit-lg">kg</span>';
        }
        if (weightSecEl) {
          weightSecEl.innerHTML = c.st + '<span class="assessment__weight-unit-sm">st</span> ' + c.lb + '<span class="assessment__weight-unit-sm">lb</span>';
        }
        if (rulerLabels) {
          var lo = Math.max(30, kg - 5);
          var hi = Math.min(200, kg + 5);
          rulerLabels.innerHTML = '<span>' + lo + '</span><span>' + kg + '</span><span>' + hi + '</span>';
        }
        selectAnswer(q.id, String(kg));
      }

      function scheduleWeightUpdate(kg) {
        if (_wRafId) cancelAnimationFrame(_wRafId);
        _wRafId = requestAnimationFrame(function () {
          updateWeightDisplay(kg);
          _wRafId = null;
        });
      }

      function touchXToWeightValue(clientX) {
        var rect = weightRange.getBoundingClientRect();
        var ratio = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
        var min = parseInt(weightRange.min, 10) || 35;
        var max = parseInt(weightRange.max, 10) || 300;
        return Math.round(min + ratio * (max - min));
      }

      if (weightRange) {
        selectAnswer(q.id, weightRange.value);

        weightRange.addEventListener('input', function () {
          scheduleWeightUpdate(parseInt(weightRange.value, 10));
        });
        weightRange.addEventListener('change', function () {
          scheduleWeightUpdate(parseInt(weightRange.value, 10));
        });

        weightRange.addEventListener('touchstart', function (e) {
          if (e.touches && e.touches[0]) {
            var kg = touchXToWeightValue(e.touches[0].clientX);
            weightRange.value = kg;
            scheduleWeightUpdate(kg);
          }
        }, { passive: false });

        weightRange.addEventListener('touchmove', function (e) {
          e.preventDefault();
          if (e.touches && e.touches[0]) {
            var kg = touchXToWeightValue(e.touches[0].clientX);
            weightRange.value = kg;
            scheduleWeightUpdate(kg);
          }
        }, { passive: false });

        weightRange.addEventListener('touchend', function () {
          scheduleWeightUpdate(parseInt(weightRange.value, 10));
        }, { passive: true });
      }

      var weightSubmit = container.querySelector('[data-action="submit-weight"]');
      if (weightSubmit) {
        weightSubmit.addEventListener('click', function () {
          var val = state.answers[q.id];
          if (val) {
            goTo(q.next);
          }
        });
      }
    }

    if (q.type === 'height-slider') {
      var heightRange = container.querySelector('[data-input="height-range"]');
      var heightValueEl = container.querySelector('[data-height-value]');
      var heightSecEl = container.querySelector('[data-height-secondary]');
      var heightRulerLabels = container.querySelector('[data-height-ruler-labels]');
      var _hRafId = null;

      function updateHeightDisplay(cm) {
        var c = cmToFtIn(cm);
        if (heightValueEl) {
          heightValueEl.innerHTML = cm + '<span class="assessment__weight-unit-lg">cm</span>';
        }
        if (heightSecEl) {
          heightSecEl.innerHTML = c.ft + '<span class="assessment__weight-unit-sm">ft</span> ' + c.in + '<span class="assessment__weight-unit-sm">in</span>';
        }
        if (heightRulerLabels) {
          var lo = Math.max(100, cm - 5);
          var hi = Math.min(220, cm + 5);
          heightRulerLabels.innerHTML = '<span>' + lo + '</span><span>' + cm + '</span><span>' + hi + '</span>';
        }
        selectAnswer(q.id, String(cm));
      }

      function scheduleHeightUpdate(cm) {
        if (_hRafId) cancelAnimationFrame(_hRafId);
        _hRafId = requestAnimationFrame(function () {
          updateHeightDisplay(cm);
          _hRafId = null;
        });
      }

      function touchXToHeightValue(clientX) {
        var rect = heightRange.getBoundingClientRect();
        var ratio = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
        var min = parseInt(heightRange.min, 10) || 100;
        var max = parseInt(heightRange.max, 10) || 220;
        return Math.round(min + ratio * (max - min));
      }

      if (heightRange) {
        selectAnswer(q.id, heightRange.value);

        heightRange.addEventListener('input', function () {
          scheduleHeightUpdate(parseInt(heightRange.value, 10));
        });
        heightRange.addEventListener('change', function () {
          scheduleHeightUpdate(parseInt(heightRange.value, 10));
        });

        heightRange.addEventListener('touchstart', function (e) {
          if (e.touches && e.touches[0]) {
            var cm = touchXToHeightValue(e.touches[0].clientX);
            heightRange.value = cm;
            scheduleHeightUpdate(cm);
          }
        }, { passive: false });

        heightRange.addEventListener('touchmove', function (e) {
          e.preventDefault();
          if (e.touches && e.touches[0]) {
            var cm = touchXToHeightValue(e.touches[0].clientX);
            heightRange.value = cm;
            scheduleHeightUpdate(cm);
          }
        }, { passive: false });

        heightRange.addEventListener('touchend', function () {
          scheduleHeightUpdate(parseInt(heightRange.value, 10));
        }, { passive: true });
      }

      var heightSubmit = container.querySelector('[data-action="submit-height"]');
      if (heightSubmit) {
        heightSubmit.addEventListener('click', function () {
          var val = state.answers[q.id];
          if (val) {
            goTo(q.next);
          }
        });
      }
    }
  }

  /* ---- Init ---- */

  function init() {
    config = window.assessmentConfig;
    if (!config || !config.questions || config.questions.length === 0) return;

    container = document.getElementById('assessment-app');
    if (!container) return;

    assetUrlBase = container.getAttribute('data-asset-url') || '';

    clearState();
    state.currentId = config.questions[0].id;

    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
